import React, { useState } from "react"
import classes from "./SideNav.module.scss"
import { useStaticQuery, graphql, Link } from "gatsby"

const SideNav = ({ type }) => {
  const [viewAll, setViewAll] = useState(false)
  const [clicked, setClicked] = useState(false)

  const data = useStaticQuery(graphql`
    {
      allMarkdownRemark(
        sort: { order: ASC, fields: frontmatter___image___birthtime }
      ) {
        nodes {
          id
          frontmatter {
            title
            postType
          }
          fields {
            slug
          }
        }
      }
    }
  `)

  // Counter to display number of elements in UI, not in the total search.
  let navCount = 0

  if (type === "static") {
    return <></>
  } else {
    return (
      <>
        <ul className={classes.SideNav}>
          {data.allMarkdownRemark.nodes.map((node, i) => {
            if (node.frontmatter.postType === type) {
              navCount++
              return (
                <Link
                  to={node.fields.slug}
                  className={classes.Link}
                  activeClassName={classes.NavActive}
                  getProps={({ location, href }) =>
                    `${location.pathname}/` === href ||
                    location.pathname === href
                      ? { className: classes.NavActive }
                      : {}
                  }
                  key={node.id}
                >
                  <li>
                    <p className={viewAll ? classes.pActive : null}>
                      <span className={classes.Number}>{`0${navCount}`}</span>{" "}
                      <span className={classes.Title}>
                        {node.frontmatter.title}
                      </span>
                    </p>
                  </li>
                </Link>
              )
            } else {
              return null
            }
          })}
          <button
            onMouseEnter={() => {
              if (!clicked) setViewAll(true)
            }}
            onMouseOut={() => {
              if (!clicked) setViewAll(false)
            }}
            onClick={() => {
              if (!clicked) {
                setViewAll(true)
                setClicked(true)
                console.log(viewAll, clicked)
              } else {
                setViewAll(false)
                setClicked(false)
                console.log(viewAll, clicked)
              }
            }}
          >
            {!clicked ? `show all` : `hide all`}
          </button>
        </ul>
      </>
    )
  }
}

export default SideNav
